<template>
  <v-app>
    <app-bar />
    <v-main class="base-background">
      <v-container fluid>
        <router-view v-show="!tokenIsInvalid" />
        <loading-dialog />
        <v-dialog
          v-if="tokenIsInvalid"
          v-model="tokenIsInvalid"
          max-width="500"
          persistent
        >
          <relogin :userType="session.type" />
        </v-dialog>
      </v-container>
    </v-main>
    <bottom-bar />
    <confirm ref="confirm"></confirm>
  </v-app>
</template>

<script>
import AppBar from '@/components/shared/app-bar/AppBar.vue'
import BottomBar from '@/components/shared/bottom-bar/BottomBar.vue'
import { mapGetters, mapState } from 'vuex'
import LoadingDialog from '@/components/shared/loading-dialog/LoadingDialog'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'

// import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
export default {
  name: 'App',
  components: {
    AppBar,
    BottomBar,
    LoadingDialog,
    Confirm,
    Relogin: () => import('@/components/unique/login/Relogin'),
    // BaseDialog,
  },
  computed: {
    ...mapGetters({
      authUser: 'authModule/getAuthUser',
      session: 'authModule/getSession',
    }),
    ...mapState('authModule', ['tokenInvalid']),
    tokenIsInvalid() {
      return this.tokenInvalid
    },
  },
  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
    window.addEventListener('beforeunload', this.updatePage, false)
  },
  methods: {
    async updatePage(e) {
      var confirmationMessage = 'o'
      let routesBlockedReload = ['PDV', 'register']
      let routeName = this.$route.name
      let found = null
      found = routesBlockedReload.find((ele) => {
        if (routeName) return routeName.indexOf(ele) !== -1
        else return null
      })
      if ((found && e) || this.tokenIsInvalid) {
        e.returnValue = confirmationMessage
        // Gecko, Trident, Chrome 34+
        return confirmationMessage // Gecko, WebKit, Chrome <34
      } else return null
    },
  },
}
</script>

<style lang="css">
.base-background {
  /* background-image: url('/images/background/bg1/olive.jpg'); */
  background-image: url('/images/logo/logo.png');
  /* background-repeat: repeat; */
  background-size: 150px;
  background-position: center;
  background-color: #eeeeee;
}
/* Cor de fundo do autocomplete */
input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 25px rgb(90, 90, 90) inset;
}

/* Cor do texto do autocomplete */
input:-webkit-autofill {
  -webkit-text-fill-color: white !important;
}
</style>
